// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as DigitalWorkersRouteImport } from './routes/digital-workers'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as ImplementationRouteImport } from './routes/implementation'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SolutionsRouteImport } from './routes/solutions'
import { Route as WhatIsCargonovaRouteImport } from './routes/what-is-cargonova'
import { Route as BlogAiVsRpaLogisticsRouteImport } from './routes/blog/ai-vs-rpa-logistics'
import { Route as BlogRoiOfAiAgentsFreightForwardingRouteImport } from './routes/blog/roi-of-ai-agents-freight-forwarding'
import { Route as BlogWhatIsAiFmsRouteImport } from './routes/blog/what-is-ai-fms'
import { Route as CompareCargonovaVsCargowiseRouteImport } from './routes/compare/cargonova-vs-cargowise'
import { Route as CompareCargowiseAlternativeRouteImport } from './routes/compare/cargowise-alternative'
import { Route as ThIndexRouteImport } from './routes/th/index'
import { Route as ThAboutRouteImport } from './routes/th/about'
import { Route as ThCustomersRouteImport } from './routes/th/customers'
import { Route as ThDigitalWorkersRouteImport } from './routes/th/digital-workers'
import { Route as ThFaqRouteImport } from './routes/th/faq'
import { Route as ThFeaturesRouteImport } from './routes/th/features'
import { Route as ThImplementationRouteImport } from './routes/th/implementation'
import { Route as ThPricingRouteImport } from './routes/th/pricing'
import { Route as ThPrivacyRouteImport } from './routes/th/privacy'
import { Route as ThSolutionsRouteImport } from './routes/th/solutions'
import { Route as ThWhatIsCargonovaRouteImport } from './routes/th/what-is-cargonova'
import { Route as ZhIndexRouteImport } from './routes/zh/index'
import { Route as ZhAboutRouteImport } from './routes/zh/about'
import { Route as ZhCustomersRouteImport } from './routes/zh/customers'
import { Route as ZhDigitalWorkersRouteImport } from './routes/zh/digital-workers'
import { Route as ZhFaqRouteImport } from './routes/zh/faq'
import { Route as ZhFeaturesRouteImport } from './routes/zh/features'
import { Route as ZhImplementationRouteImport } from './routes/zh/implementation'
import { Route as ZhPricingRouteImport } from './routes/zh/pricing'
import { Route as ZhPrivacyRouteImport } from './routes/zh/privacy'
import { Route as ZhSolutionsRouteImport } from './routes/zh/solutions'
import { Route as ZhWhatIsCargonovaRouteImport } from './routes/zh/what-is-cargonova'
import { Route as ThBlogAiVsRpaLogisticsRouteImport } from './routes/th/blog/ai-vs-rpa-logistics'
import { Route as ThBlogRoiOfAiAgentsFreightForwardingRouteImport } from './routes/th/blog/roi-of-ai-agents-freight-forwarding'
import { Route as ThBlogWhatIsAiFmsRouteImport } from './routes/th/blog/what-is-ai-fms'
import { Route as ThCompareCargonovaVsCargowiseRouteImport } from './routes/th/compare/cargonova-vs-cargowise'
import { Route as ThCompareCargowiseAlternativeRouteImport } from './routes/th/compare/cargowise-alternative'
import { Route as ZhBlogAiVsRpaLogisticsRouteImport } from './routes/zh/blog/ai-vs-rpa-logistics'
import { Route as ZhBlogRoiOfAiAgentsFreightForwardingRouteImport } from './routes/zh/blog/roi-of-ai-agents-freight-forwarding'
import { Route as ZhBlogWhatIsAiFmsRouteImport } from './routes/zh/blog/what-is-ai-fms'
import { Route as ZhCompareCargonovaVsCargowiseRouteImport } from './routes/zh/compare/cargonova-vs-cargowise'
import { Route as ZhCompareCargowiseAlternativeRouteImport } from './routes/zh/compare/cargowise-alternative'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const CustomersRoute = CustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => rootRouteImport
          })
const DigitalWorkersRoute = DigitalWorkersRouteImport.update({
            id: '/digital-workers',path: '/digital-workers',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FeaturesRoute = FeaturesRouteImport.update({
            id: '/features',path: '/features',getParentRoute: () => rootRouteImport
          })
const ImplementationRoute = ImplementationRouteImport.update({
            id: '/implementation',path: '/implementation',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SolutionsRoute = SolutionsRouteImport.update({
            id: '/solutions',path: '/solutions',getParentRoute: () => rootRouteImport
          })
const WhatIsCargonovaRoute = WhatIsCargonovaRouteImport.update({
            id: '/what-is-cargonova',path: '/what-is-cargonova',getParentRoute: () => rootRouteImport
          })
const BlogAiVsRpaLogisticsRoute = BlogAiVsRpaLogisticsRouteImport.update({
            id: '/blog/ai-vs-rpa-logistics',path: '/blog/ai-vs-rpa-logistics',getParentRoute: () => rootRouteImport
          })
const BlogRoiOfAiAgentsFreightForwardingRoute = BlogRoiOfAiAgentsFreightForwardingRouteImport.update({
            id: '/blog/roi-of-ai-agents-freight-forwarding',path: '/blog/roi-of-ai-agents-freight-forwarding',getParentRoute: () => rootRouteImport
          })
const BlogWhatIsAiFmsRoute = BlogWhatIsAiFmsRouteImport.update({
            id: '/blog/what-is-ai-fms',path: '/blog/what-is-ai-fms',getParentRoute: () => rootRouteImport
          })
const CompareCargonovaVsCargowiseRoute = CompareCargonovaVsCargowiseRouteImport.update({
            id: '/compare/cargonova-vs-cargowise',path: '/compare/cargonova-vs-cargowise',getParentRoute: () => rootRouteImport
          })
const CompareCargowiseAlternativeRoute = CompareCargowiseAlternativeRouteImport.update({
            id: '/compare/cargowise-alternative',path: '/compare/cargowise-alternative',getParentRoute: () => rootRouteImport
          })
const ThIndexRoute = ThIndexRouteImport.update({
            id: '/th/',path: '/th/',getParentRoute: () => rootRouteImport
          })
const ThAboutRoute = ThAboutRouteImport.update({
            id: '/th/about',path: '/th/about',getParentRoute: () => rootRouteImport
          })
const ThCustomersRoute = ThCustomersRouteImport.update({
            id: '/th/customers',path: '/th/customers',getParentRoute: () => rootRouteImport
          })
const ThDigitalWorkersRoute = ThDigitalWorkersRouteImport.update({
            id: '/th/digital-workers',path: '/th/digital-workers',getParentRoute: () => rootRouteImport
          })
const ThFaqRoute = ThFaqRouteImport.update({
            id: '/th/faq',path: '/th/faq',getParentRoute: () => rootRouteImport
          })
const ThFeaturesRoute = ThFeaturesRouteImport.update({
            id: '/th/features',path: '/th/features',getParentRoute: () => rootRouteImport
          })
const ThImplementationRoute = ThImplementationRouteImport.update({
            id: '/th/implementation',path: '/th/implementation',getParentRoute: () => rootRouteImport
          })
const ThPricingRoute = ThPricingRouteImport.update({
            id: '/th/pricing',path: '/th/pricing',getParentRoute: () => rootRouteImport
          })
const ThPrivacyRoute = ThPrivacyRouteImport.update({
            id: '/th/privacy',path: '/th/privacy',getParentRoute: () => rootRouteImport
          })
const ThSolutionsRoute = ThSolutionsRouteImport.update({
            id: '/th/solutions',path: '/th/solutions',getParentRoute: () => rootRouteImport
          })
const ThWhatIsCargonovaRoute = ThWhatIsCargonovaRouteImport.update({
            id: '/th/what-is-cargonova',path: '/th/what-is-cargonova',getParentRoute: () => rootRouteImport
          })
const ZhIndexRoute = ZhIndexRouteImport.update({
            id: '/zh/',path: '/zh/',getParentRoute: () => rootRouteImport
          })
const ZhAboutRoute = ZhAboutRouteImport.update({
            id: '/zh/about',path: '/zh/about',getParentRoute: () => rootRouteImport
          })
const ZhCustomersRoute = ZhCustomersRouteImport.update({
            id: '/zh/customers',path: '/zh/customers',getParentRoute: () => rootRouteImport
          })
const ZhDigitalWorkersRoute = ZhDigitalWorkersRouteImport.update({
            id: '/zh/digital-workers',path: '/zh/digital-workers',getParentRoute: () => rootRouteImport
          })
const ZhFaqRoute = ZhFaqRouteImport.update({
            id: '/zh/faq',path: '/zh/faq',getParentRoute: () => rootRouteImport
          })
const ZhFeaturesRoute = ZhFeaturesRouteImport.update({
            id: '/zh/features',path: '/zh/features',getParentRoute: () => rootRouteImport
          })
const ZhImplementationRoute = ZhImplementationRouteImport.update({
            id: '/zh/implementation',path: '/zh/implementation',getParentRoute: () => rootRouteImport
          })
const ZhPricingRoute = ZhPricingRouteImport.update({
            id: '/zh/pricing',path: '/zh/pricing',getParentRoute: () => rootRouteImport
          })
const ZhPrivacyRoute = ZhPrivacyRouteImport.update({
            id: '/zh/privacy',path: '/zh/privacy',getParentRoute: () => rootRouteImport
          })
const ZhSolutionsRoute = ZhSolutionsRouteImport.update({
            id: '/zh/solutions',path: '/zh/solutions',getParentRoute: () => rootRouteImport
          })
const ZhWhatIsCargonovaRoute = ZhWhatIsCargonovaRouteImport.update({
            id: '/zh/what-is-cargonova',path: '/zh/what-is-cargonova',getParentRoute: () => rootRouteImport
          })
const ThBlogAiVsRpaLogisticsRoute = ThBlogAiVsRpaLogisticsRouteImport.update({
            id: '/th/blog/ai-vs-rpa-logistics',path: '/th/blog/ai-vs-rpa-logistics',getParentRoute: () => rootRouteImport
          })
const ThBlogRoiOfAiAgentsFreightForwardingRoute = ThBlogRoiOfAiAgentsFreightForwardingRouteImport.update({
            id: '/th/blog/roi-of-ai-agents-freight-forwarding',path: '/th/blog/roi-of-ai-agents-freight-forwarding',getParentRoute: () => rootRouteImport
          })
const ThBlogWhatIsAiFmsRoute = ThBlogWhatIsAiFmsRouteImport.update({
            id: '/th/blog/what-is-ai-fms',path: '/th/blog/what-is-ai-fms',getParentRoute: () => rootRouteImport
          })
const ThCompareCargonovaVsCargowiseRoute = ThCompareCargonovaVsCargowiseRouteImport.update({
            id: '/th/compare/cargonova-vs-cargowise',path: '/th/compare/cargonova-vs-cargowise',getParentRoute: () => rootRouteImport
          })
const ThCompareCargowiseAlternativeRoute = ThCompareCargowiseAlternativeRouteImport.update({
            id: '/th/compare/cargowise-alternative',path: '/th/compare/cargowise-alternative',getParentRoute: () => rootRouteImport
          })
const ZhBlogAiVsRpaLogisticsRoute = ZhBlogAiVsRpaLogisticsRouteImport.update({
            id: '/zh/blog/ai-vs-rpa-logistics',path: '/zh/blog/ai-vs-rpa-logistics',getParentRoute: () => rootRouteImport
          })
const ZhBlogRoiOfAiAgentsFreightForwardingRoute = ZhBlogRoiOfAiAgentsFreightForwardingRouteImport.update({
            id: '/zh/blog/roi-of-ai-agents-freight-forwarding',path: '/zh/blog/roi-of-ai-agents-freight-forwarding',getParentRoute: () => rootRouteImport
          })
const ZhBlogWhatIsAiFmsRoute = ZhBlogWhatIsAiFmsRouteImport.update({
            id: '/zh/blog/what-is-ai-fms',path: '/zh/blog/what-is-ai-fms',getParentRoute: () => rootRouteImport
          })
const ZhCompareCargonovaVsCargowiseRoute = ZhCompareCargonovaVsCargowiseRouteImport.update({
            id: '/zh/compare/cargonova-vs-cargowise',path: '/zh/compare/cargonova-vs-cargowise',getParentRoute: () => rootRouteImport
          })
const ZhCompareCargowiseAlternativeRoute = ZhCompareCargowiseAlternativeRouteImport.update({
            id: '/zh/compare/cargowise-alternative',path: '/zh/compare/cargowise-alternative',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CustomersRoute: CustomersRoute,DigitalWorkersRoute: DigitalWorkersRoute,FaqRoute: FaqRoute,FeaturesRoute: FeaturesRoute,ImplementationRoute: ImplementationRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,SolutionsRoute: SolutionsRoute,WhatIsCargonovaRoute: WhatIsCargonovaRoute,BlogAiVsRpaLogisticsRoute: BlogAiVsRpaLogisticsRoute,BlogRoiOfAiAgentsFreightForwardingRoute: BlogRoiOfAiAgentsFreightForwardingRoute,BlogWhatIsAiFmsRoute: BlogWhatIsAiFmsRoute,CompareCargonovaVsCargowiseRoute: CompareCargonovaVsCargowiseRoute,CompareCargowiseAlternativeRoute: CompareCargowiseAlternativeRoute,ThAboutRoute: ThAboutRoute,ThCustomersRoute: ThCustomersRoute,ThDigitalWorkersRoute: ThDigitalWorkersRoute,ThFaqRoute: ThFaqRoute,ThFeaturesRoute: ThFeaturesRoute,ThImplementationRoute: ThImplementationRoute,ThPricingRoute: ThPricingRoute,ThPrivacyRoute: ThPrivacyRoute,ThSolutionsRoute: ThSolutionsRoute,ThWhatIsCargonovaRoute: ThWhatIsCargonovaRoute,ZhAboutRoute: ZhAboutRoute,ZhCustomersRoute: ZhCustomersRoute,ZhDigitalWorkersRoute: ZhDigitalWorkersRoute,ZhFaqRoute: ZhFaqRoute,ZhFeaturesRoute: ZhFeaturesRoute,ZhImplementationRoute: ZhImplementationRoute,ZhPricingRoute: ZhPricingRoute,ZhPrivacyRoute: ZhPrivacyRoute,ZhSolutionsRoute: ZhSolutionsRoute,ZhWhatIsCargonovaRoute: ZhWhatIsCargonovaRoute,ThIndexRoute: ThIndexRoute,ZhIndexRoute: ZhIndexRoute,ThBlogAiVsRpaLogisticsRoute: ThBlogAiVsRpaLogisticsRoute,ThBlogRoiOfAiAgentsFreightForwardingRoute: ThBlogRoiOfAiAgentsFreightForwardingRoute,ThBlogWhatIsAiFmsRoute: ThBlogWhatIsAiFmsRoute,ThCompareCargonovaVsCargowiseRoute: ThCompareCargonovaVsCargowiseRoute,ThCompareCargowiseAlternativeRoute: ThCompareCargowiseAlternativeRoute,ZhBlogAiVsRpaLogisticsRoute: ZhBlogAiVsRpaLogisticsRoute,ZhBlogRoiOfAiAgentsFreightForwardingRoute: ZhBlogRoiOfAiAgentsFreightForwardingRoute,ZhBlogWhatIsAiFmsRoute: ZhBlogWhatIsAiFmsRoute,ZhCompareCargonovaVsCargowiseRoute: ZhCompareCargonovaVsCargowiseRoute,ZhCompareCargowiseAlternativeRoute: ZhCompareCargowiseAlternativeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)